import { resize } from './components/header/resize.js';


document.addEventListener("DOMContentLoaded", function () {
    // Helper function to create an overlay message
    function createConsentOverlay(element, message) {
        const overlay = document.createElement('div');
        overlay.style.position = 'absolute';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        overlay.style.color = 'white';
        overlay.style.display = 'flex';
        overlay.style.flexDirection = "column";
        overlay.style.alignItems = 'center';
        overlay.style.justifyContent = 'center';
        overlay.style.textAlign = 'center';
        overlay.style.padding = '10px';
        overlay.style.zIndex = '10';
        overlay.style.boxSizing = "border-box";
        overlay.style.fontFamily = "system-ui, sans-serif";
        overlay.style.cursor = "pointer";
        overlay.classList.add("_flo-consent-embed-overlay");
        overlay.innerHTML = message;


        const addControls = () => {
            setTimeout(() => {

                if (typeof _flo !== "undefined") {
                    overlay.innerHTML = _flo.consent.tools.token_replace(_flo.consent.defaults.translations[_flo.consent.config.language].embed_overlay.title);
                    const button = document.createElement("div");
                    button.style.padding = "10px 20px";
                    button.style.borderRadius = "30px";
                    button.style.textAlign = "center";
                    button.style.border = "1px solid white";
                    button.style.marginTop = "20px";
                    button.innerText = _flo.consent.tools.token_replace(_flo.consent.defaults.translations[_flo.consent.config.language].embed_overlay.description);

                    overlay.appendChild(button);
                    overlay.onclick = () => {
                        _flo.consent.tools.actions.displayContextual();
                    }
                } else {
                    restoreEmbeds();
                }

            },3000);
        }
        if (window.google_tag_manager) {
                addControls();            
        } else {
            window.addEventListener("flo.consent.gtm_loaded", () => {
                addControls();            
            });
        }
        
        const container = document.createElement("div");
        container.style.width = element.style.width || "100%";
        container.style.height = element.style.height || element.getBoundingClientRect().height;
        container.style.position = "relative";

        container.append(overlay);
        element.insertAdjacentElement('beforebegin',container);
        element.style.position = "relative";
        container.appendChild(element);
    }

    // Function to disable embeds that might set cookies until consent is granted
    function disableEmbed(embedElement, message) {
        // Move src to data-flosrc to prevent it from loading
        embedElement.setAttribute('data-flosrc', embedElement.src);
        embedElement.removeAttribute('src');

        // Create an overlay message
        createConsentOverlay(embedElement, message);
    }


    // Function to handle other video platforms (add more platforms as needed)
    function handleEmbeds(iframe) {
        const src = iframe.getAttribute('src');

        // Check for Vimeo or other video platforms and handle accordingly
        if (src && src.includes('vimeo.com')) {
            disableEmbed(iframe, "");
        } else {
            disableEmbed(iframe, "");
        }
    }

    // Handle all iframes and media that might set cookies
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach(iframe => {
        const src = iframe.getAttribute('src');
        if (src) {
            const srcUrl = new URL(src);
            if (srcUrl.hostname && srcUrl.hostname !== location.hostname) {
                handleEmbeds(iframe);
            }
        }
    });

    // Restore media after consent is given
    window.addEventListener('flo.consent.targeting', function () {
      restoreEmbeds();
    });
    function restoreEmbeds() {
        const elementsToRestore = document.querySelectorAll('[data-flosrc]');
        elementsToRestore.forEach(element => {
            element.setAttribute('src', element.getAttribute('data-flosrc'));
            element.removeAttribute('data-flosrc');
            
            // Remove the overlay
            const overlay = element.parentElement.querySelector('._flo-consent-embed-overlay');
            if (overlay) {
                overlay.remove();
            }
        });
    }
    const currentConsent = window.localStorage.getItem('_flo-consent');
    if (currentConsent) {
        try {
            const consentObj = JSON.parse(atob(currentConsent));
            if (consentObj[0] && consentObj[0].targeting) {
                restoreEmbeds();
            }
        } catch(ex) {
            console.log("Could not parse consent options", ex);
        }

    }
});

resize();